/**
 * usePageBackground - Hook para setear background de página usando Asset system
 *
 * @param {string} key - Asset key (e.g., 'bg.dashboard', 'bg.lobby')
 *
 * @example
 * // En Dashboard.jsx
 * usePageBackground('bg.dashboard');
 *
 * // En LobbyView.jsx
 * usePageBackground('bg.lobby');
 */

import { useEffect, useState } from 'react';
import { Asset } from '@rts';

export function usePageBackground(key) {
  // Track theme changes to re-apply background
  const [themeSlug, setThemeSlug] = useState(() => Asset.getState().themeSlug);

  // Subscribe to Asset changes (theme changes)
  useEffect(() => {
    const unsubscribe = Asset.subscribe((state) => {
      if (state.themeSlug !== themeSlug) {
        setThemeSlug(state.themeSlug);
      }
    });
    return unsubscribe;
  }, [themeSlug]);

  // Apply background when key or theme changes
  useEffect(() => {
    // Obtener URL del background
    let url;
    if (Asset.isLoaded()) {
      url = Asset.img(key);
    } else {
      // Fallback si Asset no está inicializado
      const brand = import.meta.env.VITE_GAME_BRAND;
      const path = key.replace('.', '/');
      url = `/${brand}/theme/base/images/${path}.webp`;
    }

    // Aplicar background al body
    document.body.style.backgroundImage = `url(${url})`;
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundPosition = 'center';
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundAttachment = 'fixed';

    // Cleanup al desmontar
    return () => {
      document.body.style.backgroundImage = '';
      document.body.style.backgroundSize = '';
      document.body.style.backgroundPosition = '';
      document.body.style.backgroundRepeat = '';
      document.body.style.backgroundAttachment = '';
    };
  }, [key, themeSlug]);
}

export default usePageBackground;
